import React, { useState, useEffect, useCallback } from 'react';
import { supabase } from '../supabaseclient';

export default function Relatorios() {
  const [aba, setaba] = useState('beneficios');
  const [lista, setlista] = useState([]);
  const [carregando, setcarregando] = useState(false);
  const [filtro, setfiltro] = useState('');
  const [dia, setdia] = useState('');
  const [mes, setmes] = useState(new Date().getMonth() + 1);
  const [ano, setano] = useState(new Date().getFullYear());

  // LÓGICA DE CONTAGEM AUTOMÁTICA
  const totais = lista.reduce((acc, item) => {
    if (aba !== 'beneficios') return acc;
    const nomeItem = (item.tipo_atendimento || "").toUpperCase();
    const qtd = parseInt(item.quantidade) || 0;
    
    if (nomeItem.includes("CESTA GRANDE")) acc.cestaG += qtd;
    else if (nomeItem.includes("CESTA PEQUENA")) acc.cestaP += qtd;
    else if (nomeItem.includes("LEITE")) acc.leite += qtd;
    
    return acc;
  }, { cestaG: 0, cestaP: 0, leite: 0 });

 const buscardados = useCallback(async () => {
    setcarregando(true);
    try {
      const tabela = aba === 'beneficios' ? 'fundo_social_concessoes' : 'cadastro_campanhas';
      let { data, error } = await supabase.from(tabela).select('*');
      if (error) throw error;

      const termo = filtro.toLowerCase().trim();

      const filtrados = (data || []).filter(item => {
        // 1. FILTRO DE TEXTO (Nome ou CPF)
        const bateTexto = aba === 'beneficios' 
          ? (item.nome_beneficiario?.toLowerCase().includes(termo) || item.cpf?.includes(termo))
          : (item.campanha_realizada?.toLowerCase().includes(termo) || item.nome_contato?.toLowerCase().includes(termo));

        // SE O USUÁRIO DIGITOU ALGO, IGNORA OS FILTROS DE DATA E RETORNA TODOS OS MESES
        if (termo !== '') {
          return bateTexto;
        }

        // 2. FILTRO DE DATA (Apenas se o campo de pesquisa estiver vazio)
        const dataCampo = aba === 'beneficios' ? item.data_atual : item.data_inicial;
        if (!dataCampo) return false;

        const dataLimpa = dataCampo.split('T')[0].split(' ')[0];
        const partes = dataLimpa.split('-');
        
        const anoItem = parseInt(partes[0], 10);
        const mesItem = parseInt(partes[1], 10);
        const diaItem = parseInt(partes[2], 10);
        
        const bateAnoMes = mesItem === mes && anoItem === ano;
        const diaFiltroNum = dia !== '' ? parseInt(dia, 10) : null;
        const bateDia = diaFiltroNum === null || diaItem === diaFiltroNum;
        
        return bateAnoMes && bateDia;
      });

      // ORGANIZAÇÃO POR ORDEM ALFABÉTICA
      filtrados.sort((a, b) => {
        const nomeA = (aba === 'beneficios' ? a.nome_beneficiario : a.campanha_realizada) || "";
        const nomeB = (aba === 'beneficios' ? b.nome_beneficiario : b.campanha_realizada) || "";
        return nomeA.localeCompare(nomeB);
      });

      setlista(filtrados);
    } catch (err) {
      console.error("Erro na busca:", err.message);
    } finally {
      setcarregando(false);
    }
  }, [aba, mes, ano, filtro, dia]);
  
  useEffect(() => {
    buscardados();
  }, [buscardados]);

  const editarRegistro = (item) => {
    localStorage.removeItem('dadosEdicao');
    localStorage.setItem('dadosEdicao', JSON.stringify(item));
    const destino = aba === 'beneficios' ? 'concessao' : 'campanhas';
    window.dispatchEvent(new CustomEvent('mudarTela', { detail: destino }));
  };

  const excluirRegistro = async (id) => {
    if (!window.confirm("Deseja realmente excluir este registro?")) return;
    const tabela = aba === 'beneficios' ? 'fundo_social_concessoes' : 'cadastro_campanhas';
    const { error } = await supabase.from(tabela).delete().eq('id', id);
    if (!error) setlista(lista.filter(item => item.id !== id));
  };

  return (
    <div className="p-4 max-w-7xl mx-auto space-y-6 flex flex-col h-full relatorio-container">
      <style>{`
        @media print {
          .no-print, aside, header, footer, button { display: none !important; }
          
          html, body, #root, [class*="flex h-screen"], [class*="flex-1 flex flex-col"] {
            height: auto !important;
            overflow: visible !important;
            position: static !important;
            display: block !important;
          }
          
          .relatorio-container { height: auto !important; overflow: visible !important; display: block !important; padding: 0 !important; margin: 0 !important; }
          .area-impressao { display: block !important; height: auto !important; overflow: visible !important; border: none !important; box-shadow: none !important; width: 100% !important; }
          .overflow-y-auto { overflow: visible !important; height: auto !important; }
          
          table { width: 100% !important; border-collapse: collapse !important; page-break-inside: auto; }
          tr { page-break-inside: avoid !important; page-break-after: auto; }
          thead { display: table-header-group !important; }

          .card-resumo { 
            display: flex !important; 
            flex-direction: row !important; 
            gap: 10px !important; 
            margin-bottom: 20px !important;
          }
          .card-resumo > div { 
            border: 1px solid #e5e7eb !important; 
            flex: 1 !important; 
            background-color: #f9fafb !important;
            -webkit-print-color-adjust: exact;
          }
        }
      `}</style>

      {/* CABEÇALHO E FILTROS */}
      <div className="bg-white p-6 rounded-3xl shadow-lg no-print border border-gray-100 shrink-0">
        <div className="flex flex-wrap justify-between items-center gap-4">
          <div className="flex bg-gray-100 p-1 rounded-2xl">
            <button onClick={() => { setaba('beneficios'); setfiltro(''); setdia(''); }} className={`px-6 py-2 rounded-xl text-xs font-black transition-all ${aba === 'beneficios' ? 'bg-blue-900 text-white shadow-lg' : 'text-gray-500'}`}>BENEFÍCIOS</button>
            <button onClick={() => { setaba('campanhas'); setfiltro(''); setdia(''); }} className={`px-6 py-2 rounded-xl text-xs font-black transition-all ${aba === 'campanhas' ? 'bg-blue-900 text-white shadow-lg' : 'text-gray-500'}`}>CAMPANHAS</button>
          </div>
          <div className="flex items-center gap-2">
            <input type="number" placeholder="DIA" min="1" max="31" value={dia} onChange={(e) => setdia(e.target.value)} className="border rounded-xl px-2 py-2 text-xs font-bold bg-white outline-none w-16 text-center" />
            <select value={mes} onChange={(e) => setmes(Number(e.target.value))} className="border rounded-xl px-3 py-2 text-xs font-bold bg-white outline-none">
              {['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'].map((m, i) => (
                <option key={m} value={i + 1}>{m}</option>
              ))}
            </select>
            <button onClick={() => window.print()} className="bg-blue-900 text-white px-5 py-2 rounded-xl text-xs font-bold shadow hover:bg-blue-800 transition-all">🖨️ Imprimir</button>
          </div>
        </div>
        <input type="text" placeholder="Pesquisar por nome ou CPF..." className="w-full mt-4 p-3 bg-gray-50 border border-gray-200 rounded-2xl text-sm outline-none focus:ring-2 focus:ring-blue-900 font-bold" value={filtro} onChange={(e) => setfiltro(e.target.value)} />
      </div>

      {/* ÁREA DO RELATÓRIO */}
      <div className="bg-white p-4 sm:p-8 rounded-lg shadow-sm border border-gray-200 area-impressao">
        
        {/* CABEÇALHO TIMBRADO */}
        <div className="flex justify-between items-center border-b-2 border-black pb-4 mb-6 text-center">
          <div className="w-16 md:w-20"><img src="/brasao-mirassol.png" alt="Brasão" className="w-full" /></div>
          <div className="flex-1 px-4">
            <h1 className="text-lg font-bold uppercase leading-tight">Prefeitura Municipal de Mirassol</h1>
            <h2 className="text-md font-semibold italic text-gray-700">Fundo Social de Solidariedade</h2>
            <p className="text-[10px] font-bold mt-1 uppercase underline underline-offset-4">
              {aba === 'beneficios' ? 'Relatório de Concessões de Benefícios' : 'Relatório de Atividades de Campanhas'}
            </p>
          </div>
          <div className="w-16 md:w-24 text-right"><img src="/logo-fundo-social-black.png" alt="Logo" className="w-full" /></div>
        </div>

        {/* CARDS DE CONTAGEM */}
        {aba === 'beneficios' && (
          <div className="grid grid-cols-3 gap-4 mb-6 card-resumo">
            <div className="p-3 bg-gray-50 rounded-xl border border-gray-200 text-center">
              <p className="text-[9px] font-black uppercase text-gray-500">Cesta Grande</p>
              <p className="text-xl font-black text-blue-900">{totais.cestaG}</p>
            </div>
            <div className="p-3 bg-gray-50 rounded-xl border border-gray-200 text-center">
              <p className="text-[9px] font-black uppercase text-gray-500">Cesta Pequena</p>
              <p className="text-xl font-black text-blue-900">{totais.cestaP}</p>
            </div>
            <div className="p-3 bg-gray-50 rounded-xl border border-gray-200 text-center">
              <p className="text-[9px] font-black uppercase text-gray-500">Leite</p>
              <p className="text-xl font-black text-blue-900">{totais.leite}</p>
            </div>
          </div>
        )}

        <div className="overflow-y-auto">
          <table className="w-full border-collapse border border-black text-[9px]">
            <thead>
              <tr className="bg-gray-100 uppercase font-bold text-center">
                <th className="border border-black p-1 w-16">Data</th>
                {aba === 'beneficios' ? (
                  <>
                    <th className="border border-black p-1 text-left">Beneficiário</th>
                    <th className="border border-black p-1">CPF</th>
                    <th className="border border-black p-1">Atendimento</th>
                    <th className="border border-black p-1 w-8">Qtd</th>
                    <th className="border border-black p-1 text-left">Responsável</th>
                    <th className="border border-black p-1 text-left">Observações</th>
                  </>
                ) : (
                  <>
                    <th className="border border-black p-1 text-left">Campanha / Finalidade</th>
                    <th className="border border-black p-1 text-left">Responsável</th>
                  </>
                )}
                <th className="border border-black p-1 no-print">Ações</th>
              </tr>
            </thead>
            <tbody>
              {lista.map(item => (
                <tr key={item.id} className="text-center border-b border-gray-300">
                  <td className="border border-black p-1">
                    {(() => {
                      const d = (aba === 'beneficios' ? item.data_atual : item.data_inicial) || "";
                      if (!d) return "-";
                      const [anoItem, mesItem, diaItem] = d.split('T')[0].split(' ')[0].split('-');
                      return `${diaItem}/${mesItem}/${anoItem}`;
                    })()}
                  </td>
                  {aba === 'beneficios' ? (
                    <>
                      <td className="border border-black p-1 text-left uppercase font-medium">{item.nome_beneficiario}</td>
                      <td className="border border-black p-1">{item.cpf}</td>
                      <td className="border border-black p-1 uppercase">{item.tipo_atendimento}</td>
                      <td className="border border-black p-1 font-bold">{item.quantidade}</td>
                      <td className="border border-black p-1 text-left uppercase text-[8px]">{item.responsavel_atendimento}</td>
                      <td className="border border-black p-1 text-left uppercase text-[7px]">{item.observacoes || "-"}</td>
                    </>
                  ) : (
                    <>
                      <td className="border border-black p-1 text-left uppercase font-medium">{item.campanha_realizada}</td>
                      <td className="border border-black p-1 text-left uppercase text-[8px]">{item.responsavel_atendimento}</td>
                    </>
                  )}
                  <td className="border border-black p-1 no-print">
                    <div className="flex justify-center gap-2">
                      <button onClick={() => editarRegistro(item)} className="text-blue-600">✏️</button>
                      <button onClick={() => excluirRegistro(item.id)} className="text-red-600">🗑️</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

